import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Box, Typography, Stack, Tabs, Tab } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import PageHeader from "../../components/PageHeader";
import { getUserId } from "../../constants/function";
import MyMusicTab from "./MyMusicTab";
import MyPlaylistsTab from "./MyPlaylistsTab";
import CollectionTab from "./CollectionTab";
import MyVideosTab from "./MyVideosTab";
import MyFavoritesTab from "./MyFavoritesTab";
import bgTextChar from "../../assets/common/resources/bg_text_char.png";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

export default function Library() {
  const history = useHistory();
  const [tab, setTab] = useState(0);
  const userId = getUserId();
  const [isUploadPopupOpen, setIsUploadPopupOpen] = useState(false);

  const openUploadPopup = () => setIsUploadPopupOpen(true);
  const closeUploadPopup = () => setIsUploadPopupOpen(false);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        px: 4,
        py: 3,
        background: "linear-gradient(135deg, var(--background-color, #000) 0%, var(--background-color, #222) 100%)",
      }}
    >
      <PageHeader title="Library" />

      {/* "Create New" card */}
      <Stack direction="row" spacing={3} sx={{ mb: 4, mt: 2 }}>
        <Box
          sx={{
            background: `linear-gradient(rgba(255,224,102,0.85), rgba(255,224,102,0.85)), url(${bgTextChar}) center/cover no-repeat`,
            color: "#222",
            borderRadius: "16px",
            width: 180,
            height: 220,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "bold",
            fontSize: "1.3rem",
            cursor: "pointer",
            boxShadow: 2,
            transition: "box-shadow 0.2s, transform 0.2s",
            "&:hover": {
              boxShadow: 6,
              transform: "translateY(-4px) scale(1.03)",
            },
          }}
          onClick={openUploadPopup}
        >
          <AddIcon sx={{ fontSize: 40, mb: 1, color: "#222" }} />
          <Typography variant="h6" fontWeight={700}>
            Create New
          </Typography>
        </Box>
      </Stack>

      {/* Upload Popup */}
      <Dialog
        open={isUploadPopupOpen}
        onClose={closeUploadPopup}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          style: {
            backgroundColor: 'var(--background-color-rgba, rgba(0, 0, 0, 0.85))',
            borderRadius: 16,
            padding: '20px',
            backdropFilter: 'blur(15px)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            boxShadow: '0 4px 30px var(--background-color-rgba, rgba(0, 0, 0, 0.8))',
            overflow: 'visible',
          }
        }}
      >
        <DialogTitle sx={{ color: 'var(--text-primary, white)', textAlign: 'center', fontSize: '1.5rem', fontWeight: 'bold' }}>
          Create or Upload
        </DialogTitle>
        <DialogContent sx={{ paddingTop: '20px' }}>
          <Box display="flex" flexDirection="column" alignItems="center" gap={3}>
            <Box
              onClick={() => { closeUploadPopup(); history.push('/app/UploadMusic'); }}
              sx={{
                width: '100%',
                textAlign: 'center',
                bgcolor: '#ffe066',
                color: '#222',
                borderRadius: 2,
                py: 2,
                cursor: 'pointer',
                fontWeight: 600,
                fontSize: '1.1rem',
                mb: 1,
                transition: "background 0.2s",
                "&:hover": { bgcolor: "#fffbe6" }
              }}
            >
              Upload Music
            </Box>
            <Box
              onClick={() => { closeUploadPopup(); history.push('/app/UploadVideo'); }}
              sx={{
                width: '100%',
                textAlign: 'center',
                bgcolor: '#ffe066',
                color: '#222',
                borderRadius: 2,
                py: 2,
                cursor: 'pointer',
                fontWeight: 600,
                fontSize: '1.1rem',
                mb: 1,
                transition: "background 0.2s",
                "&:hover": { bgcolor: "#fffbe6" }
              }}
            >
              Upload Video
            </Box>
            <Box
              onClick={() => { closeUploadPopup(); history.push('/app/Playlists/create'); }}
              sx={{
                width: '100%',
                textAlign: 'center',
                bgcolor: '#ffe066',
                color: '#222',
                borderRadius: 2,
                py: 2,
                cursor: 'pointer',
                fontWeight: 600,
                fontSize: '1.1rem',
                transition: "background 0.2s",
                "&:hover": { bgcolor: "#fffbe6" }
              }}
            >
              Create Playlist / Studio
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center' }}>
          <Button onClick={closeUploadPopup} sx={{ color: '#ccc', fontWeight: 'bold' }}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* Tabs */}
      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        textColor="inherit"
        TabIndicatorProps={{ style: { background: "var(--primary-color, #ffe066)" } }}
        sx={{
          mb: 4,
          "& .MuiTab-root": {
            color: "var(--text-primary, #fff)",
            fontWeight: 600,
            fontSize: "1.1rem",
            textTransform: "none",
            mr: 4,
            minWidth: 120,
          },
          "& .Mui-selected": {
            color: "var(--primary-color, #ffe066)",
          },
        }}
      >
        <Tab label="My Music" />
        <Tab label="My Videos" />
        <Tab label="My Playlists" />
        <Tab label="Collection" />
        <Tab label="My Favorites" />
      </Tabs>

      {/* Tab Panels */}
      {tab === 0 && <MyMusicTab userId={userId} />}
      {tab === 1 && <MyVideosTab userId={userId} />}
      {tab === 2 && <MyPlaylistsTab />}
      {tab === 3 && <CollectionTab />}
      {tab === 4 && <MyFavoritesTab userId={userId} />}
    </Box>
  );
}